import { isInHorizontalBounds } from '../../core/utils/is-in-horizontal-bounds.js';
import { LABEL_FONT_SIZE } from '../types/default.js';
import type { InternalLabel } from '../types/internal/pie-chart.js';

const COLLISION_THRESHOLD = LABEL_FONT_SIZE / 2;

const oneWayCollision = (a: InternalLabel, b: InternalLabel) =>
  a.boxX >= b.boxX &&
  a.boxX <= b.boxX + b.boxWidth + COLLISION_THRESHOLD &&
  ((a.boxY >= b.boxY && a.boxY <= b.boxY + b.boxHeight + COLLISION_THRESHOLD) ||
    (a.boxY + a.boxHeight >= b.boxY - COLLISION_THRESHOLD &&
      a.boxY + a.boxHeight <= b.boxY + b.boxHeight));

export const collision = (a: InternalLabel, b: InternalLabel) =>
  oneWayCollision(a, b) || oneWayCollision(b, a);

export const isInVerticalBounds = (
  labelY: number,
  labelHeight: number,
  top: number,
) => labelY > -top && labelY + labelHeight < top;

export const isInBounds = (label: InternalLabel, left: number, top: number) =>
  isInHorizontalBounds(label.boxX, label.boxWidth, left) &&
  isInVerticalBounds(label.boxY, label.boxHeight, top);
